<template>
  <div class="sm:px-6 lg:px-8">
    <div class="h-full bg-white shadow-2xl">
      <claim-table></claim-table>
    </div>
  </div>
</template>

<script>
import ClaimTable from '@/components/ClaimTable'

export default {
  components: { ClaimTable },
}
</script>
